<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-券发放-添加
    -->
  <el-dialog
      title="发放"
      :visible.sync="dialogVisible"
      @close="dialogFormVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="50%"
  >

    <div class="product-add pb50">

      <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
        <el-form-item label="券名称" prop="voucher_id">
          <el-select 
            v-model="form.voucher_id" 
            placeholder="请选择券"
            style="width: 100%;"
            clearable
            filterable
            @change="onVoucherChange"
          >
            <el-option
              v-for="dept in voucherList"
              :key="dept.voucher_id"
              :label="dept.name"
              :value="dept.voucher_id"
            />
          </el-select>
        </el-form-item>
        
        <el-form-item label="扣除组织" prop="deduct_organization_name">
          <el-input 
            v-model="form.deduct_organization_name" 
            placeholder="选择券后自动填充" 
            class="max-w460"
            readonly
            :disabled="true"
          >
          </el-input>
        </el-form-item>
        
        <el-form-item label="单价" prop="unit_price_display">
          <el-input 
            v-model="form.unit_price_display" 
            placeholder="选择券后自动填充" 
            class="max-w460"
            readonly
            :disabled="true"
          >
          </el-input>
        </el-form-item>
        
        <el-form-item label="面额" prop="denomination">
          <el-input 
            v-model="form.denomination" 
            placeholder="选择券后自动填充" 
            class="max-w460"
            readonly
            :disabled="true"
          >
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        
        <el-form-item label="剩余数量" prop="remaining_num">
          <el-input 
            v-model="form.remaining_num" 
            placeholder="选择券后自动填充" 
            class="max-w460"
            readonly
            :disabled="true"
          ></el-input>
        </el-form-item>
        
        <el-form-item label="操作数量" prop="num">
          <el-input-number 
            v-model="form.num" 
            placeholder="请输入操作数量" 
            class="max-w460"
            :min="1"
            :max="form.max_num || 99999"
            controls-position="right"
            style="width: 100%;"
          ></el-input-number>
          <div class="el-form-item__tips" v-if="form.remaining_num">
            最大可操作数量: {{ form.remaining_num }}
          </div>
        </el-form-item>
        
        <el-form-item label="接收组织" prop="ma_organization_id">
          <el-select 
            v-model="form.ma_organization_id" 
            placeholder="请选择接收组织"
            style="width: 100%;"
            clearable
            filterable
          >
            <el-option
              v-for="dept in maOrganizationList"
              :key="dept.ma_organization_id"
              :label="dept.name"
              :value="dept.ma_organization_id"
            /> 
          </el-select>
        </el-form-item>
        
        <el-form-item label="排序" prop="sort">
          <el-input-number 
            v-model="form.sort" 
            placeholder="请输入排序" 
            class="max-w460"
            :min="0"
            :max="999"
            controls-position="right"
            style="width: 100%;"
          ></el-input-number>
        </el-form-item>
        
        <!--提交-->
        <div class="common-button-wrapper">
          <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
          <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
        </div>
      </el-form>
    </div>
  </el-dialog>

</template>

<script>
import Voucher_distributeApi from '@/api/voucher_distribute.js';
import AfuncApi from '@/api/afunc.js';

export default {
  components: {},
  data() {
    return {
      maOrganizationList: [],
      voucherList: [],
      selectedVoucher: null, // 存储选中的券信息
      
      /*form表单数据*/
      form: {
        voucher_id: '',
        name: '',
        deduct_organization_name: '',
        unit_price_display: '',
        denomination: '',
        remaining_num: '',
        num: 1,
        ma_organization_id: '',
        sort: 50,
        max_num: 0,
        // 用于提交的字段
        deduct_ma_organization_id: '', // 扣除组织ID
        unit_price: '', // 单价数值
        unit_price_unit: '', // 单价单位
      },
      loading: false,
      
      /*验证规则*/
      rules: {
        voucher_id: [{ required: true, message: '请选择券', trigger: 'change' }],
        num: [
          { required: true, message: '请输入操作数量', trigger: 'blur' },
          { type: 'number', min: 1, message: '操作数量至少为1', trigger: 'blur' }
        ],
        ma_organization_id: [{ required: true, message: '请选择接收组织', trigger: 'change' }],
      },
      dialogVisible: false,
    };
  },
  created() {
    this.loadVoucher();
    this.loadOrganization();
    this.dialogVisible = this.open_add;
  },
  props: ["open_add"],
  watch: {
    'form.remaining_num': function(newVal) {
      if (newVal) {
        this.form.max_num = parseInt(newVal);
      }
    },
    'form.num': function(newVal) {
      if (newVal > this.form.max_num) {
        this.$nextTick(() => {
          this.form.num = this.form.max_num;
        });
      }
    }
  },
  methods: {
    async loadOrganization() {
      try {
        const response = await AfuncApi.call({
          model: 'ma_organization',
          action: 'getList',
        });
        
        if (!response) {
          this.$message.warning('组织列表接口返回为空');
          this.maOrganizationList = [];
          return;
        }
        
        if (response.code === 1 && response.data.list.data) {
          this.maOrganizationList = response.data.list.data || [];
        } else {
          this.$message.warning('获取组织列表失败：' + (response.msg || '未知错误'));
          this.maOrganizationList = [];
        }
      } catch (error) {
        console.error('加载组织列表失败:', error);
        this.$message.error('加载组织列表失败，请稍后重试');
        this.maOrganizationList = [];
      }
    },
    
    async loadVoucher() {
      try {
        const response = await AfuncApi.call({
          model: 'voucher',
          action: 'getList',
          page: 1,
          list_rows: 1000
        });
        
        if (!response) {
          this.voucherList = [];
          return;
        }
        if (response.code === 1 && response.data.list) {
          this.voucherList = response.data.list.data || [];
        } else {
          this.voucherList = [];
        }
      } catch (error) {
        console.error('加载券列表失败:', error);
        this.voucherList = [];
      }
    },
    
    // 券选择变化事件
    onVoucherChange(voucherId) {
      if (!voucherId) {
        this.clearVoucherInfo();
        return;
      }
      
      // 查找选中的券信息
      const voucher = this.voucherList.find(item => item.voucher_id === voucherId);
      if (voucher) {
        this.selectedVoucher = voucher;
        this.fillVoucherInfo(voucher);
      } else {
        this.clearVoucherInfo();
      }
    },
    
    // 填充券信息
    fillVoucherInfo(voucher) {
      // 单位映射
      const unitMap = {
        0: '元/人次',
        1: '元/学时',
        2: '元/课时'
      };
      
      // 设置显示字段
      this.form.deduct_organization_name = voucher.ma_organization_name || '未知组织';
      this.form.denomination = voucher.denomination || '0';
      this.form.remaining_num = voucher.sy_num || '0';
      
      // 处理单价显示
      const unitPrice = voucher.unit_price || '0';
      const unitPriceUnit = voucher.unit_price_unit || 0;
      this.form.unit_price_display = `${unitPrice} ${unitMap[unitPriceUnit] || unitMap[0]}`;
      
      // 设置提交用的字段
      this.form.deduct_ma_organization_id = voucher.ma_organization_id;
      this.form.unit_price = unitPrice;
      this.form.unit_price_unit = unitPriceUnit;
      
      // 设置最大操作数量
      this.form.max_num = parseInt(voucher.sy_num) || 0;
      
      // 如果当前操作数量大于最大数量，调整为最大数量
      if (this.form.num > this.form.max_num) {
        this.form.num = this.form.max_num;
      }
    },
    
    // 清空券信息
    clearVoucherInfo() {
      this.selectedVoucher = null;
      this.form.deduct_organization_name = '';
      this.form.unit_price_display = '';
      this.form.denomination = '';
      this.form.remaining_num = '';
      this.form.deduct_ma_organization_id = '';
      this.form.unit_price = '';
      this.form.unit_price_unit = '';
      this.form.max_num = 0;
    },
    
    /*关闭弹窗*/
    dialogFormVisible(result) {
      this.clearForm();
      this.$emit("close", { openDialog: false, "type": "" });
    },
    
    // 清空表单
    clearForm() {
      this.form = {
        voucher_id: '',
        name: '',
        deduct_organization_name: '',
        unit_price_display: '',
        denomination: '',
        remaining_num: '',
        num: 1,
        ma_organization_id: '',
        sort: 50,
        max_num: 0,
        deduct_ma_organization_id: '',
        unit_price: '',
        unit_price_unit: '',
      };
      this.selectedVoucher = null;
      this.$refs.form.clearValidate();
    },
    
    // 提交表单
    onSubmit() {
      let self = this;
      self.$refs.form.validate(valid => {
        if (valid) {
          // 验证操作数量不能超过剩余数量
          if (self.form.num > self.form.max_num) {
            self.$message.error(`操作数量不能超过剩余数量(${self.form.max_num})`);
            return;
          }
          
          // 准备提交数据
          const submitData = {
            voucher_id: self.form.voucher_id,
            deduct_ma_organization_id: self.form.deduct_ma_organization_id,
            unit_price: self.form.unit_price,
            unit_price_unit: self.form.unit_price_unit,
            denomination: self.form.denomination,
            num: self.form.num,
            ma_organization_id: self.form.ma_organization_id,
            sort: self.form.sort,
            // 可以添加其他必要字段
          };
          
          self.loading = true;
          Voucher_distributeApi.add(submitData, true)
              .then(data => {
                self.loading = false;
                if (data.code === 1) {
                  self.$message({
                    message: data.msg,
                    type: 'success'
                  });
                  self.dialogFormVisible("success");
                  self.$emit("refresh"); // 通知父组件刷新列表
                } else {
                  self.$message.error(data.msg || '提交失败');
                }
              })
              .catch(error => {
                self.loading = false;
                self.$message.error('提交失败，请稍后重试');
              });
        }
      });
    },
    
    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.clearForm();
      this.$emit("close", { openDialog: false, "type": "" });
    },
  }
};
</script>

<style scoped>
.el-form-item__tips {
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
}

.max-w460 {
  max-width: 460px;
}

.pb50 {
  padding-bottom: 50px;
}

.common-button-wrapper {
  text-align: center;
  margin-top: 30px;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/voucher_distribute/index/part/add.vue